import { render, staticRenderFns } from "./FieldItem.vue?vue&type=template&id=463e9adc&scoped=true"
import script from "./FieldItem.vue?vue&type=script&lang=js"
export * from "./FieldItem.vue?vue&type=script&lang=js"
import style0 from "./FieldItem.vue?vue&type=style&index=0&id=463e9adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e9adc",
  null
  
)

export default component.exports